<pm-dialog
  [visible]="true"
  i18n-header
  [header]="'System wykrył nieprawidłowe użycie'"
  headerIcon="error"
  [closable]="false"
  [hideActions]="true"
  styleClass="max-dialog-width"
>
  <div>
    <pm-error-message
      i18n-message
      message="
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod rhoncus imperdiet. Phasellus dapibus malesuada aliquet. Donec et nibh nisl. Nam sit amet nibh cursus, eleifend nibh ac, pellentesque leo. Duis malesuada nibh urna, in facilisis lorem elementum id. Proin quis ultrices libero. Praesent pretium nisi eget neque semper luctus. Cras consectetur tristique tellus, ac faucibus nunc vulputate et. Curabitur eleifend, sem non suscipit aliquam, nisl velit ultrices odio, eu lobortis justo neque id nunc."
    />
  </div>
</pm-dialog>
